export class S3FileNameHelper {
  /** Every character outside S3's safe set for object key names becomes an underscore. */
  static sanitize(fileName: string): string {
    return fileName.replaceAll(/[^a-zA-Z0-9!\-_.*'()]/g, '_');
  }
}
